export function sepaCheckoutKey(config, previous, crypto = globalThis.crypto) {
    const payload = JSON.stringify({organisation: config.organisation?.id, assoc: config.assoc || 'MAIN',
        type: config.type, typeId: config.typeId, parentTypeId: config.parentTypeId,
        service: config.service, campagne: config.campagne, dettes: config.dettes, checkoutId: config.checkoutId,
        source: config.source, externalRef: config.externalRef, externalMetadata: config.externalMetadata,
        montant: config.montant, devise: config.devise, abo: config.abo, nbMonth: config.nbMonth,
        maxAmount: config.maxAmount, firstCollectionDate: config.firstCollectionDate, name: config.name,
        info: config.info, facturation: config.facturation, commentaire: config.commentaire,
        lang: config.lang, cerfa: config.cerfa, cerfaYear: config.cerfaYear, validateAssoc: config.validateAssoc,
        returnUrl: config.returnUrl, accessId: config.accessId, source: config.source});
    return previous?.payload === payload ? previous : {payload, key: crypto.randomUUID()};
}
export function mandateCheckoutUrl(token, origin, locale) {
    if (!/^[a-zA-Z0-9_-]{43}$/.test(token || '')) throw new Error('SEPA_SESSION_INVALID');
    const url = new URL('/sepa-xml', origin);
    url.searchParams.set('lang', ['fr', 'en', 'he', 'de', 'it', 'pt', 'ru', 'es', 'gr', 'ro'].includes(locale) ? locale : 'fr');
    url.hash = `checkout=${token}`;
    return url.href;
}

export function isSepaXmlEnabledFor(org, assoc) {
    return !!org?.id && Array.isArray(org.config) && org.config.some(config =>
        config?.key === 'SEPA_XML_PAIEMENT_METHOD' && config.organisation === org.id
        && config.assoc === assoc);
}
